import { useCallback, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import api from '../../api/axios';

export default function useLiteProducts() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const [catRes, prodRes] = await Promise.all([api.get('/categories'), api.get('/products')]);
      setCategories(catRes.data || []);
      setProducts(prodRes.data || []);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Unable to load products.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return { products, categories, loading, reload: loadData };
}
